import React from "react";
import classes from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import Affix from "../../../../components/affix";
import { useHistory } from "react-router-dom";
import { Iconfont } from "../../../../components/icon/iconfont";
import { useApp } from "../../../../hooks/common";

export const ReminderHeader = props =>{
    useStyles(classes);
    const history = useHistory();

    return <div className={`${classes.NavBar}`} style={{...props?.style}}>
        <span className={classes.Left} onClick={()=>history.goBack()}>
            <Iconfont className={classes.Icon} style={{...props?.textStyle}}>&#xe7c7;</Iconfont>
        </span>

        <div className={classes.Content}>
            {props?.centerSlot}
        </div>

        <div className={classes.Right}>
            {props?.rightSlot}
        </div>

        {props?.children}
    </div>
}

export const Header = props =>{
    useStyles(classes);
    const history = useHistory();

    const handleClose = () =>{
        if(props?.onClose){
            props.onClose?.();
        }else{
            history.goBack();
        }
    }

    return <div className={`${classes.NavBar}`} style={{...props?.style}}>
        <span className={classes.Left} onClick={()=>handleClose()}>
            <Iconfont className={classes.Icon} style={{...props?.textStyle}}>&#xe7c7;</Iconfont>
        </span>

        <div className={classes.Content}>
            {props?.centerSlot}
        </div>

        <div className={classes.Right}>
            {props?.rightSlot}
        </div>
    </div>
}

export default props =>{
    useStyles(classes);

    const isApp = useApp();

    return <React.Fragment>
        {
            !isApp && <Affix offsetTop={0}>
                <Header {...props} />
            </Affix>
        }
    </React.Fragment>
    
}